module.exports = __webpack_public_path__ + "img/JT_icons01_64px_Places.d8af6368.svg";